import React from 'react';
import PropTypes from 'prop-types';

/**
 * Links that represent the given data for each subjects card. These are coupled with icons using the titleToIcons obj
 */
const IconLinks = (props) => {
	const { products, title } = props;

	// TODO: Remove tempObject after API return has been updated.
	let tempObject;

	tempObject = products.filter(item => (item.label !== 'Essay Lab') && item);
	let links = { ...tempObject }; // TODO: Replace tempObject with products after API return has been updated.

	let titleToIcons = {
		'Courses': 'https://media1.shmoop.com/images/sitewide/teachericon-shmoop.svg',
		'Test Prep Home': 'https://media1.shmoop.com/images/sitewide/studyguidesicon-shmoop.svg',
		'Study Guides': 'https://media1.shmoop.com/images/sitewide/studyguidesicon-shmoop.svg',
		'Videos': 'https://media1.shmoop.com/images/sitewide/videoicon-shmoop.svg',
		'Math Shack': 'https://media1.shmoop.com/images/sitewide/studyguideicon-shmoop.svg'
	};

	return (
		<div className={'icon-links'}>
			{Object.keys(links).map((key, item) =>
				<div key={key}>
					<a href={links[key].url} data-item={item} className={'pl-0'}>
						<img src={titleToIcons[links[key].label]} alt={title + ': ' + links[key].label}/>
					</a>
					<a href={links[key].url} data-item={item}>
						{links[key].label}
					</a>
				</div>
			)}
		</div>
	);
};

export default IconLinks;

IconLinks.propTypes = {
	products: PropTypes.array,
	title: PropTypes.string
};
